import React, {useState, useEffect} from 'react';
import ServerWizardBody from './ServerWizardBody';
import Api from '../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../api/consts';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import {ServerCreateSchema} from '../../../api/DBSchema/Server';
import {useIsMountedRef} from '../../../utils/hooks';

function ServerWizard({
    isOpen,
    onRequestClose,
    onSuccess,
    groupName
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const isMountedRef = useIsMountedRef();

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [smsAddress, setSmsAddress] = useState('');
    const [smpServerAddress, setSmpServerAddress] = useState('');
    const [smpNatAddress, setSmpNatAddress] = useState('');

    const onFinish = async () => {
        const createServerRequestObj = {
            [ServerCreateSchema.name]: name,
            [ServerCreateSchema.smsAddress]: smsAddress,
            [ServerCreateSchema.smpServerAddress]: smpServerAddress,
            [ServerCreateSchema.smpNatAddress]: smpNatAddress,
            [ServerCreateSchema.groupName]: groupName
        }
        setIsLoading(true);
        Api.createObject(ObjectTypes.SERVER, createServerRequestObj)
        .then(() => {
            if (isMountedRef.current) {
                onSuccess(name);
            }
        })
        .catch (e => {
            if (isMountedRef.current) {
                const errorMessage = getErrorMessage(e);
                alert(errorMessage);
            }
        })
        .finally(() => {
            if (isMountedRef.current) {
                setIsLoading(false);
            } 
        });
    }

    // Reset to defaults on every open
    useEffect(() => {
        if (isOpen) {
            setName('');
            setSmsAddress('');
            setSmpServerAddress('');
            setSmpNatAddress('');
        }
    }, [isOpen]);

    const wizardVars = {
        name, setName,
        smsAddress, setSmsAddress,
        smpServerAddress, setSmpServerAddress,
        smpNatAddress, setSmpNatAddress
    }

    return (
        <SMCModal
            title={t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.HEADINGS')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={650}
            height={700}
            loading={isLoading}
        >
            <ServerWizardBody
                onFinish={onFinish}
                onCancel={onRequestClose}
                wizardVars={wizardVars}
            />
        </SMCModal>
    );
}

export default ServerWizard;